import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-ec6bdb16"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "contacts-page holder-fluid"
};

const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"contacts\" data-v-ec6bdb16><div class=\"item support\" data-v-ec6bdb16> Служба поддержки: <br data-v-ec6bdb16>По всем вопросам обращайтесь <br data-v-ec6bdb16>в службу поддержки L-Collection </div><div class=\"item email\" data-v-ec6bdb16> Email: <br data-v-ec6bdb16>panaioti.daria@mail.ru <br data-v-ec6bdb16>Телефон: 8 800 101-90-46 </div><div class=\"item address\" data-v-ec6bdb16> Адрес: <br data-v-ec6bdb16>Москва, Пресненская набережная, 12, Башня <br data-v-ec6bdb16>Федерация, Западный вход, 55 этаж </div><div class=\"item time\" data-v-ec6bdb16> Часы работы: <br data-v-ec6bdb16>ПН-ПТ с 10:00 до 19:00 </div></div>", 1);

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1));

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ymap_marker = _resolveComponent("ymap-marker");

  const _component_yandex_map = _resolveComponent("yandex-map");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createVNode(_component_yandex_map, {
    coords: [55.749633, 37.537434]
  }, {
    default: _withCtx(() => [_createVNode(_component_ymap_marker, {
      coords: [55.749633, 37.537434],
      properties: {
        // iconCation: 'caption',
        hintContent: 'L-Collection',
        balloonContent: 'Москва, Пресненская набережная, 12, Башня Федерация, Западный вход, 55 этаж',
        balloonContentHeader: 'L-Collection' // balloonContentBody: 'Москва, Пресненская набережная, 12, Башня Федерация, Западный вход, 55 этаж',
        // balloonContentFooter: 'balloonContentFooter',

      }
    }, null, 8, ["coords"])]),
    _: 1
  }, 8, ["coords"]), _hoisted_3]);
}